import { mapApiTeamToEditForm } from "../../../../../utils/teamMappers";

export function buildTeamEditForm(team) {
  return mapApiTeamToEditForm(team);
}
